import { render } from "./payImgDialog.vue?vue&type=template&id=2b6c8476&scoped=true"
import script from "./payImgDialog.vue?vue&type=script&lang=js"
export * from "./payImgDialog.vue?vue&type=script&lang=js"

import "./payImgDialog.vue?vue&type=style&index=0&id=2b6c8476&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6c8476"]])

export default __exports__